module.exports = __webpack_public_path__ + "assets/e07e8169563f4e3b774f329233766da7.png";